import React from 'react';
import { TrustIframe } from 'components/Trolley/Trust/trust-iframe';
import { Col, Row } from 'react-styled-flexboxgrid';
import Section from './section';
import SectionHeaderBar from './section-header-bar';
import SubSection from './sub-section';

export function Kyc() {
  return (
    <>
      <Section>
        <SubSection>
          <SectionHeaderBar name="Identity Verification" />
          <Col>
            <Row>
              <Col xs={12}>
                <TrustIframe />
              </Col>
            </Row>
          </Col>
        </SubSection>
      </Section>
    </>
  );
}
